import { render, staticRenderFns } from "./Basic.vue?vue&type=template&id=e8bac0e6&scoped=true"
import script from "./Basic.vue?vue&type=script&lang=js"
export * from "./Basic.vue?vue&type=script&lang=js"
import style0 from "./Basic.vue?vue&type=style&index=0&id=e8bac0e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8bac0e6",
  null
  
)

export default component.exports